<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="!cxt.isFilterMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-layout v-show="cxt.isFilterMode()" justify-end>
            <v-flex sm6 xs8>
              <v-text-field
                autofocus
                label="Фильтр"
                v-show="cxt.isFilterMode()"
                :value="cxt.filterString"
                v-on:input="onChangeFilter"
                solo flat
              ></v-text-field>
            </v-flex>
          </v-layout>
            <span v-show="!cxt.isSelectMode()">
              <span v-show="!cxt.isFilterMode()">
                <v-btn  icon @click="openDeed(null)">
                  <v-icon>add</v-icon>
                </v-btn>
              </span>
            </span>
          <v-ops-btn :cxt="cxt" flat></v-ops-btn>
      </v-toolbar>
      <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
      <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage">
        <v-list
        three-line dense>
          <template v-for="item in this.filteredItems">
            <v-list-tile v-bind:key="getItemKey(item)" @click.stop="!cxt.isSelectMode() ? openItem(item) : cxt.select(getItemKey(item))"
            :value="cxt.activated(getItemKey(item))"
            active-class="v-dealger-favorite-active v-list__tile--highlighted"
            >
              <v-list-tile-content>
                <v-list-tile-title v-html="renderReference(item)"></v-list-tile-title>
                <v-list-tile-sub-title>
                  {{formats.blank(item.notes)}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text v-show="!cxt.isSelectMode()"> {{formatState(item.state)}} </v-list-tile-action-text>
              <span v-show="cxt.isSelectMode()">
                <v-list-tile-action-text>  {{formatState(item.state)}} </v-list-tile-action-text>
                <v-icon v-show="cxt.check(item.id)">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(item.id)">check_box_outline_blank</v-icon>
              </span>
              <v-list-tile-action-text> {{item.accountNameShort}}</v-list-tile-action-text>
              <v-tooltip bottom open-delay="500" max-width="20em">
                  <v-list-tile-action-text slot="activator"><b>{{formats.blank(item.changed, formats.formatDate)}}</b></v-list-tile-action-text>
                    Изменено: {{formats.blank(item.changed, formats.formatDateTime)}}
                    Создано: {{formats.blank(item.created, formats.formatDateTime)}}
               </v-tooltip>
            </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-scroll>

    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import dialogs from '../common/dialogs'
  import vOpsBtn from '../common/OpsBtn'
  import vCardScroll from '../common/CardScroll'
  import assist from './index.js'

  class RemoveAssistAction extends classes.Action {
    constructor (context) {
      super(context,
        'Удалить дела',
        null,
        () => {
          this.context.deleteAssists(this.context.cxt.selectedIds)
        }
        )
    }
  }
  class CopyAssistAction extends classes.Action {
    constructor (context) {
      super(context,
        'Создать по образцу',
        null,
        () => {
          this.context.copyAssists(this.context.cxt.selectedIds)
        }
        )
    }
  }

  export default {
    name: 'assist-set',
    components: {vOpsBtn, vCardScroll},
    mixins: [apimix],
    data: () => ({
      cxt: null,
      order: 'BY_UPDATED'
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      cxt.actions.push(new classes.Action(this, 'Упорядочить по дате создания', () => this.order !== 'BY_CREATED',
        () => {
          this.order = 'BY_CREATED'
          this.onChangeSort()
        }))
      cxt.actions.push(new classes.Action(this, 'Упорядочить по дате изменения', () => this.order !== 'BY_UPDATED',
        () => {
          this.order = 'BY_UPDATED'
          this.onChangeSort()
        }))
      cxt.actions.push(new classes.Action(this, 'Упорядочить по названию', () => this.order !== 'BY_NAME',
        () => {
          this.order = 'BY_NAME'
          this.onChangeSort()
        }))
      // cxt.actions.push(new classes.ActiveScopeAction(cxt))
      cxt.actions.push(new classes.AllScopeAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.Action(this, 'Новый пакет', null,
        () => assist.open('PACKAGE')))
      cxt.actions.push(new classes.Action(this, 'Новый документ', null,
        () => assist.open('DEED')))
      cxt.actions.push(new classes.Action(this, 'Новая подшивка', null,
        () => assist.open('BINDER')))
      cxt.actions.push(new classes.Action(this, 'Новая рассылка', null,
        () => assist.open('POST')))
      cxt.actions.push(new classes.Action(this, 'Новая претензия', null,
        () => assist.open('CLAIM')))
      cxt.actions.push(new classes.Action(this, 'Проверить контрагента', null,
        () => assist.open('CONTRACTOR_CHECK')))
      cxt.selectActions.push(new classes.FilterAction(cxt))
      cxt.selectActions.push(new classes.FilterEndAction(cxt))
      cxt.selectActions.push(new CopyAssistAction(this))
      cxt.selectActions.push(new RemoveAssistAction(this))

      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectAllAction(cxt))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Делопроизводство'
      cxt.titleIcon = 'school'
      cxt.selectTitle = 'Выбор дела'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.fetchData(true)
      this.setActivated()
    },
    props: {
    },
    watch: {
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getAssistMatterSet',
        getAssistMatters: 'getAssistMatters',
        getProfileHaveClient: 'getProfileHaveClient',
        getRefToUrl: 'getRefToUrl'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.name,
              item.notes,
              item.accountNameShort
            )
        }

        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return this.orderedItems
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setAssistMatterFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchAssistMatters', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      getSortString () {
        switch (this.order) {
          case 'BY_NAME':
            return 'name,asc'
          case 'BY_UPDATED':
            return 'changed,desc'
          case 'BY_CREATED':
            return 'created,desc'
          default:
            return 'changed,desc'
        }
      },
      onChangeSort (v) {
        this.$store.commit('setAssistMatterSort', this.getSortString())
        this.changeFilterContext(null, true)
      },
      fetchData (force) {
        if (this.getProfileHaveClient) {
          this.$store.commit('setAssistMatterSort', this.getSortString())
          this.changeFilterContext({tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false}, force)
        }
      },
      nextPage () {
        this.$store.commit('nextAssistMatters')
        this.$store.dispatch('fetchAssistMatters')
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      setActivated () {
        if (this.$router && this.$router.options && this.$router.options.from) {
          let from = this.$router.options.from
          if (from.params && from.params.matterId) {
            let itemId = from.params.matterId
            if (itemId === 'deed') {
              this.cxt.activate(null)
              return
            }
            let item = this.items.find(i => this.getItemKey(i) === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
        }
      },
      formatTypeCode (typeCode) {
        switch (typeCode) {
          case 'CLAIM':
            return 'Претензия'
          case 'DEED':
            return 'Документ'
          default:
            return typeCode
        }
      },
      formatState (state) {
        if (/NEW/i.test(state)) {
          return 'Новое'
        }
        if (/CLOSED/i.test(state)) {
          return 'Завершено'
        }
        return state
      },
      renderReference (item, target) {
        return ''.concat(
          `<b><a :href=" ${this.getItemRef(item)}">${item.name}</a></b>`
        )
      },
      getItemKey (item) {
        return item ? item.id : null
      },
      getItemRef (item) {
        return assist.getItemRef(item.id)
      },
      openItem (item) {
        assist.open(item.id)
      },
      deleteAssists (selectedIds) {
        if (Array.isArray(selectedIds)) {
          dialogs.confirm(this,
          'Подтвердите',
          `Удалить ${selectedIds.length} дела?`,
          (self) => {
            self.$store.dispatch('deleteAssistMatters', {ids: selectedIds})
            self.cxt && self.cxt.toViewMode()
          })
        }
      },
      copyAssists (selectedIds) {
        if (Array.isArray(selectedIds)) {
          dialogs.confirm(this,
          'Подтвердите',
          `Создать ${selectedIds.length} новых дела на основе выбранных?`,
          (self) => {
            self.$store.dispatch('copyAssistMatters', {ids: selectedIds})
            self.cxt && self.cxt.toViewMode()
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AssistSet.vue?22c9fb50